export const API_URL = "http://localhost:9000";

// export const MONGODB_URL = "https://bronzed-skinny-technician.glitch.me/";
// export const MONGODB_URL = "cit-backend-qoizje9ot-mohamd-adels-projects.vercel.app";
// export const MONGODB_URL = "https://cit-backend-ebgg.onrender.com";
// export const MONGODB_URL = "https://fine-gray-puffer-boot.cyclic.app";
export const MONGODB_URL = "https://cit-backend.vercel.app";
// export const MONGODB_URL = "https://cit-backend-2hic.onrender.com";
// export const MONGODB_URL = "cit-backend-git-master-mohamd-adels-projects.vercel.app";
// export const MONGODB_URL = "https://mohamed1adel.github.io/CIT-Backend";